import React from 'react';

const Login2PageConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false
				},
				toolbar: {
					display: false
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	},
	routes: [
		{
			path: '/login',
			component: React.lazy(() => import('./Login2Page'))
		}
	]
};

export default Login2PageConfig;
